

















































































import AdminApi from "@/api/adminApi";

import { Component, Prop, Vue } from "vue-property-decorator";
import QNotify from "@/common/qNotify";
import adminApi from "@/api/adminApi";
import { namespace } from "vuex-class";
import QErrors from "@/common/qErrors.vue";
import { compareWithKeys } from "@/common/utils";

const authStore = namespace("Auth");

@Component({
  name: "AdminEdit",
  components: {
    QErrors,
  },
})
export default class AdminEdit extends Vue {
  @Prop({
    default: function () {
      return {
        administrator_code: "",
        administrator_name: "",
        login_id: "",
        login_password: "",
      };
    },
  })
  editData;
  @Prop({
    default: function () {
      return {
        administrator_code: "",
        administrator_name: "",
        login_id: "",
        login_password: "",
      };
    },
  })
  editDataInit;

  @authStore.Getter
  getAdminUser;

  public errors = [];
  public isShow = false;

  get title() {
    return this.editData.administrator_code
      ? this.$t("admin.title_edit", { name: this.editData.administrator_name })
      : this.$t("admin.title_create");
  }

  public clearErrors() {
    this.errors = [];
  }

  public handleChangePassword(event) {
    if (event.target.value.includes("•")) {
      this.editData.login_password = event.data;
    }
  }

  public confirmDelete(): void {
    this.$modal.showDelete({
      confirmClass: "mb__add-color-red",
      text: `${this.editData.administrator_name} を削除します。この操作は取り消せません。`,
      onConfirm: () => {
        this.deleteAdmin();
      },
    });
  }

  public isDisableDelete() {
    return (
      this.editData.administrator_code === this.getAdminUser.administrator_code
    );
  }

  public confirmCancel(): void {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.cancel_message", {
          name: this.editData.administrator_name,
        })}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public statusError(field) {
    return this.errors[field] ? "error" : "";
  }

  public clearError(field) {
    this.errors[field] = "";
    this.$forceUpdate();
  }

  public prepareEditData() {
    if (this.editData.login_password === "••••••••") {
      this.editData.login_password = "";
    }
  }

  async submit(): Promise<void> {
    this.prepareEditData();

    if (this.editData.administrator_code) {
      await this.update();
    } else {
      await this.add();
    }
  }

  async add() {
    try {
      await adminApi.add(this.editData).then((response) => {
        if (response.status === 200) {
          QNotify.success({
            text: this.$t("common.message.created"),
          });

          this.isShow = false;
          this.reloadAdminList();
        } else {
          QNotify.error({
            text: response.data.meta.message,
          });
          this.errors = response.data.meta.errors;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  async update() {
    try {
      await adminApi
        .update(this.editData, this.editData.administrator_code)
        .then((response) => {
          if (response.status === 200) {
            QNotify.success({
              text: this.$t("common.message.updated"),
            });

            this.isShow = false;
            this.reloadAdminList();
          } else {
            QNotify.error({
              text: response.data.meta.message,
            });
            this.errors = response.data.meta.errors;
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  public deleteAdmin() {
    AdminApi.delete(this.editData.administrator_code)
      .then((response) => {
        if (response.status === 200) {
          QNotify.success({
            text: this.$t("common.message.deleted"),
          });
          this.isShow = false;
          this.reloadAdminList();
        } else {
          QNotify.error({
            text: response.data.meta.message,
          });
        }
      })
      .catch((error) => {
        if (error.status === 404) {
          this.isShow = false;
          QNotify.error({
            text: "該当データは既に削除されています。",
          });
          this.reloadAdminList();
        }
      });
  }

  public reloadAdminList() {
    this.$root.$emit("fetchAdminList", this.$route.query);
  }

  public isChanged() {
    return compareWithKeys(this.editData, this.editDataInit, [
      "administrator_code",
      "administrator_name",
      "login_id",
      "login_password",
    ]);
  }
}
